import axios from "axios";
import { toast } from "react-toastify";
import { isSignout } from "../redux/authSlice";

let Get = async (url, accessToken, dispatch) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  };
  try {
    const res = await axios.get(url, options);
    return res;
  } catch (error) {
    if (error?.response?.status === 423) {
      dispatch(isSignout());
    }
    if (error?.message == "Network Error") {
      toast.error("Please check your internet connection", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (error?.message == "Please login to get access") {
      toast.error("Please login to get access", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else if (error?.message == "Not authorized to access this route") {
      toast.error("You are not authorized to access this page", {
        position: toast.POSITION.TOP_CENTER,
      });
    } else {
      toast.error(error?.response?.data?.error, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  }
};
export { Get };

let Post = async (url, body, accessToken, formData = false) => {
  const options = {
    headers: {
      Accept: "application/json",
      "Content-Type": !formData ? "application/json" : "multipart/form-data",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
    timeout: 1800000 * 2, // 30 minutes x 2 = 1 hour timeout
  };
  try {
    const res = await axios.post(url, body, options);
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.error, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};
export { Post };

let Patch = async (url, body, accessToken, formData = false) => {
  const options = {
    headers: {
      "Content-Type": !formData ? "application/json" : "multipart/form-data",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  };
  try {
    const res = await axios.patch(url, body, options);
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.error, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};
export { Patch };

let Delete = async (url, accessToken) => {
  const options = {
    headers: {
      "Content-Type": "application/json",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  };
  try {
    const res = await axios.delete(url, options);
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.error, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};

let Put = async (url, body, accessToken, formData = false) => {
  const options = {
    headers: {
      "Content-Type": !formData ? "application/json" : "multipart/form-data",
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  };
  try {
    const res = await axios.put(url, body, options);
    return res;
  } catch (error) {
    toast.error(error?.response?.data?.error, {
      position: toast.POSITION.TOP_CENTER,
    });
  }
};
export { Put };

export { Delete };
